import type { FieldMinimalListResponseApi } from '@ingenico/api-sdk-provisioning-public';
import type { FieldConfiguration } from '@ingenico/react-ui/advanced-search';

export function mapOrganizationMinimalListToFieldConfiguration(
  response: FieldMinimalListResponseApi,
): FieldConfiguration[] {
  return response.map(({ key, type }) => ({
    key,
    type,
    visible: true,
    searchable: !key.includes('parent'),
  })) as FieldConfiguration[];
}
